import styled from "styled-components";

export const Container = styled.div`
  .MuiAppBar-root {
    z-index: 1;
  }

  .appBarDesktop {
    z-index: 10;
    background: #FFFFFF;
    color: rgba(0, 0, 0, 0.60);
    box-shadow: none;

    .title {
      width: 300px;
    }
    .alertBlockDay{
      background-color: #E64A19;
      color: white;
      text-align: center;
      font-weight: bold;
    }
    .container {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .select {
        padding-left: 10px;
        display: flex;
        align-items: center;

        .icon {

          svg {
            width: 35px;

            * {
              fill: white;
            }
          }
        }

        .input {
          padding-left: 10px;
        }
      }

      .actions {

        .blockedVehiclesIcon {
          position: relative;
          bottom: 3px;
        }

        .MuiButtonBase-root {
          border-radius: 0;
        }

        .iconNotifications {

          svg {
            position: relative;
            top: 1px;
          }
        }

        .active {

          svg {
            fill: red;
          }
        }

        svg {
          width: 1.8rem;
          fill: #002951;
        }

        #menuIcon {
          svg {
            fill: #002951;
          }
        }
      }

      #actionPopperSpeedingAlerts, #actionPopperCanAlerts, #actionPopperImproperDischarge, #actionPopperBlockedVehicles {

        svg {
          fill: #BEBEBE;
          color: #BEBEBE;
        }

        .red-fill svg, svg.red-fill {
          fill: #FF0000;
          color: #FF0000;
        }

      }

      .logo_and_language_container {
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }

        .logo {
          cursor: pointer;

          img {
            width: 130px;
          }
        }
    }
  }

  .appBarMobile {
    z-index: 10;
    top: 0;
    bottom: auto;
    background: #FFFFFF;
    color: rgba(0, 0, 0, 0.60);
    box-shadow: 0 -4px 5px -6px #333;
    border-top: 1px solid #ccc;

    .MuiToolbar-root {
      flex-wrap: nowrap;
      padding-right: 8px;
    }

    .alertBlockDay{
      background-color: #E64A19;
      color: white;
      text-align: center;
      font-weight: bold;
    }

    .actions {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: nowrap;
      flex: 1;
      gap: 2px;
      overflow-x: auto;
      padding-top: 10px;
      margin-top: -10px;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      &.scroll-right {
        mask-image: linear-gradient(to right, black 85%, transparent 100%);
      }

      &.scroll-left {
        mask-image: linear-gradient(to left, black 85%, transparent 100%);
      }

      &.scroll-both {
        mask-image: linear-gradient(to right, transparent 0%, black 15%, black 85%, transparent 100%);
      }

      #actionPopperSpeedingAlerts, #actionPopperCanAlerts, #actionPopperImproperDischarge, #actionPopperBlockedVehicles {

        svg {
          fill: #BEBEBE;
          color: #BEBEBE;
        }

        .red-fill svg, svg.red-fill {
          fill: #FF0000;
          color: #FF0000;
        }

      }

      .blockedVehiclesIcon {
        position: relative;
        bottom: 4px;
      }

      .iconNotifications {
        top: 2px;
        position: relative;
      }

      .active {

        svg {
          fill: red;
        }
      }

      button {
        padding: 7px;
      }

      svg {
        font-size: 1.8rem;
        width: 1.8rem;
        fill: #002951;
      }

    }

    #menuIcon {
      padding: 8px 12px 12px 12px;

      svg {
        fill: #002951;
      }
    }

  }
`;

export const ContainerSVGMenuIcon = styled.span`
  svg {
    height: 22.5px;
    width: 22.5px;
    fill: #757575;
  }
`;
